import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';
import { ImportValidationResult } from '../../modules/community/components/MemberImportErrorReview';

type ReturnType = Promise<AxiosResponse<ImportResponse>>;

export type ImportErrorResponse = {
    import_errors: String[];
};

export type ImportResponse =
    | ImportValidationResult
    | { status: 'import_started' }
    | ImportErrorResponse;

const importMembers = (group: Group, tmpFilePath: string): ReturnType => {
    return Request.post(`/imports/group/members/${group.uuid}`, {
        file: tmpFilePath,
    });
};

export default importMembers;
